import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { ConstantsModule } from './../constants/constants.module';
import { CookieService } from 'ngx-cookie-service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { AlertLineData } from '../alert-line/alert-line-data';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public alertLine: AlertLineData = new AlertLineData();

  public loginForm: FormGroup = new FormGroup({
    username: new FormControl('', [Validators.required, Validators.pattern(/.+@.+\..+/)]),
    password: new FormControl('', [Validators.required])
  });

  constructor(private constantsModule: ConstantsModule, private cookieService: CookieService, private httpClient: HttpClient, private router: Router, private _modalService: NgbModal) {
  }

  ngOnInit() {
    // Checking if data are already stored.
    let username: string = this.cookieService.get(this.constantsModule.cookieUser);
    let token: string = this.cookieService.get(this.constantsModule.cookieToken);

    if (token != "" && token != undefined) {
      // The token is present.

      // Testing token validity.
      var newData = {
        "username": username
      };
      this.httpClient.post(this.constantsModule.serverFullURL + "/secure/check-token", newData, this.constantsModule.httpOptions).subscribe(
          (response:any) => {
              if (response.DATA == "ERR" || response.RES == 0) {
                // The token is not valid.
                this.cookieService.delete(this.constantsModule.cookieToken);
                this.fillingLoginFormData(username);
              } else {
                // The token is valid, routing to home page.
                this.router.navigateByUrl("/home");
              }
          },
          (err:any) => {
            this.cookieService.delete(this.constantsModule.cookieToken);
            this.fillingLoginFormData(username);
          }
      );
    } else {
      this.fillingLoginFormData(username);
    }
  }

  // Only filling data.
  private fillingLoginFormData(username: string) {
    if (username != "" && username != undefined) {
      this.cookieService.delete(this.constantsModule.cookieRole);
      this.loginForm.get("username")!.setValue(username);
    }
  }

  /**
   * Logging in for a user.
   */
  login() {
    // If this works, storing data locally.
    this.httpClient.post(this.constantsModule.serverFullURL + "/secure/login", { 'username': this.loginForm.value["username"], 'password': this.loginForm.value["password"] }, this.constantsModule.httpOptions).subscribe(
      (response: any) => {
        // Data must contains a ROLE property.
        if (response.DATA == "ERR") {
          switch (response.VALUE) {
            case "NOT FOUND":
              this.alertLine.alertDangerMessage = "Login ou mot de passe incorrect.";
              break;
            case "SYSTEM":
              this.alertLine.alertDangerMessage = "Le serveur a retourné des valeurs incorrectes. Merci de contacter votre administrateur.";
              break;
            default:
              this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
              break;
          }
        } else {
          // Saving roles, token and routing to home page.
          this.cookieService.set(this.constantsModule.cookieUser, this.loginForm.value["username"]);
          this.cookieService.set(this.constantsModule.cookieRole, response.ROLE);
          this.cookieService.set(this.constantsModule.cookieToken, response.TOKEN);

          this.router.navigateByUrl("/home");
        };
      },
      (err) => {
        // Server error found.
        this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur. Merci de contacter votre administrateur.";
      }
    );
  }

  /**
   * Reset login form.
   */
  resetForm() {
    this.loginForm.controls["username"].setValue("");
    this.loginForm.controls["password"].setValue("");
  }

	public resetPassword(): void {
		// Réinitalisation de la ligne d'alert.
		this.alertLine.resetAllMessages();

		this._modalService.open(ResetPasswordComponent).result.then(
			(result) => {
				// envoie demande au serveur.
				if (result == "FERMETURE") return;

				switch (result) {
					case "SYSTEM":
            this.alertLine.alertDangerMessage = "Le serveur a retourné des valeurs incorrectes. Merci de contacter votre administrateur.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Merci de contacter votre administrateur.";
						break;
					case "NOT FOUND":
						this.alertLine.alertDangerMessage = "Utilisateur inconnu ou désactivé. Opération annulée.";
						break;
					case "CANNOT UPDATE ENTITY":
						this.alertLine.alertDangerMessage = "Impossible de mettre à jour votre mot de passe. Merci de contacter votre administrateur.";
						break;
          default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + result.VALUE + "). Contactez votre administrateur.";
						break;
				}
			},
			(reason) => {
				// annuler ==> rien.
				if (reason == 0 || reason == 1) {
					// Fenêtre annulée.
					return;
				}

				if (reason == "OK") {
					this.alertLine.alertSuccessMessage = "Un email vient de vous être envoyé. Veuillez consulter votre boîte mail.";
				}
			}
		);
	}
}
